/* istanbul ignore file */
import { grid, maxWidthContainerWithoutGutters } from '@noths/polaris-client-ribbons-base';
import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { spacing } = themeVariables;

export const wrapper = css`
  margin: 0 0 var(${spacing.xl}) 0;
`;

/*
 * First on the page there is no preceding section to space us off the site header, so add the gap
 * ourselves. Further down the page the previous section's bottom margin already covers it.
 */
export const firstSectionWrapper = css`
  ${wrapper}
  margin-top: var(${spacing.md});
`;

export const container = css`
  ${grid}
  ${maxWidthContainerWithoutGutters};
  grid-row-gap: 0;
  padding: 0;
`;
